export enum Login {
    Login,
    Register,
    Guest,
    Token
}

export enum List {
    Spawns,
    Positions
}

export enum Equipment {
    Batch,
    Equip,
    Unequip,
    Style
}

export enum Movement {
    Request,
    Started,
    Step,
    Stop,
    Move,
    Follow,
    Entity,
    Speed
}

export enum Target {
    Talk,
    Attack,
    None,
    Object
}

export enum Combat {
    Initiate,
    Hit,
    Finish,
    Sync
}

export enum Projectile {
    Static,
    Dynamic,
    Create,
    Update,
    Impact
}

export enum Network {
    Ping,
    Pong
}

export enum Container {
    Batch,
    Add,
    Remove,
    Select,
    Swap,
    Sort
}

export enum Ability {
    Batch,
    Add,
    Update,
    Use,
    QuickSlot,
    Toggle,
    ItemQuickSlot
}

export enum Quest {
    Batch,
    Progress,
    Finish,
    FlagSubmit,
    AvailableNPCs // sync del set de NPCs con quest disponible para el player
}

export enum Achievement {
    Batch,
    Progress
}

export enum Notification {
    Ok,
    YesNo,
    Text,
    Popup
}

export enum Experience {
    Sync,
    Skill
}

export enum NPC {
    Talk,
    Store,
    Bank,
    Enchant,
    Countdown,
    Info,
    Book
}

export enum Trade {
    Request,
    Add,
    Remove,
    Accept,
    Close,
    Open
}

export enum Enchant {
    Select,
    Confirm
}

export enum Guild {
    Create,
    Login,
    Logout,
    Join,
    Leave,
    Rank,
    Update,
    Experience,
    Banner,
    List,
    Error,
    Chat,
    Invite,
    AllianceRequest,
    AllianceAccept,
    AllianceDecline,
    AllianceBreak,
    HostileDeclare,
    HostileRemove,
    DiplomacyList,
    SkillTree,
    SkillUpgrade
}

export enum Pointer {
    Location, // Pointer on the map
    Relative, // Pointer relative to the screen
    Entity, // Pointer following an entity
    Remove,
    Button // Pointer for a button
}

export enum Store {
    Open,
    Close,
    Buy,
    Sell,
    Update,
    Select
}

export enum TeamWar {
    Score,
    End,
    Lobby,
    Exit
}

export enum Overlay {
    Set,
    Remove,
    Lamp,
    RemoveLamps,
    Darkness
}

export enum Camera {
    LockX,
    LockY,
    FreeFlow,
    Player
}

export enum Command {
    CtrlClick
}

export enum Skill {
    Batch,
    Update,
    Boost
}

export enum Minigame {
    TeamWar
}

export enum Bubble {
    Entity,
    Position
}

export enum Effect {
    Add,
    Remove
}

export enum Friends {
    List,
    Add,
    Remove,
    Status,
    Sync,
    Online
}

export enum Player {
    Login,
    Logout
}

export enum Crafting {
    Open,
    Select,
    Craft
}

export enum Party {
    Invite, // Server → client: you received an invite from X
    Accept, // Client → server: accept pending invite
    Decline, // Client → server: decline invite
    Leave, // Client → server / server → client: leave party
    Disband, // Server → client: party disbanded
    Update, // Server → client: full member list refresh
    Request // Client → server: /party invite [name]
}

export enum CoinRanking {
    Request, // Client → server: request the CoinCTF ranking
    Batch // Server → client: full ranking list
}

export enum PlayerShop {
    Open, // Client → server: enter shop mode (send listed items)
    Close, // Client → server: exit shop mode
    SetItem, // Client → server: list an inventory item for sale
    RemoveItem, // Client → server: unlist an item
    Browse, // Client → server: request a player's shop / Server → client: shop data
    Buy, // Client → server: purchase an item from a player shop
    Update // Server → client: shop updated (item sold, etc.)
}

export enum CTFChallenge {
    Open, // Server → client: open the CTF menu (triggered by talking to hackl4bs)
    Request, // Client → server: request the current campaign state
    Batch, // Server → client: full campaign state (nodes, progress, current node)
    Submit, // Client → server: submit a flag for the current CTF node
    Result, // Server → client: outcome of a submit (correct/incorrect, reward, next node)
    KillProgress, // Server → client: progress update for a kill-type node (killed N/M)
    TreasureFound, // Client → server: player interacted with the treasure chest for this node
    QuestionAnswer // Client → server: submit an answer for a question node
}

export enum PetAbility {
    Activate, // Client → server: activate a pet ability by key
    Effect, // Server → client: ability activated feedback (name, type, duration)
    List // Server → client: send all unlocked abilities with state
}

export enum Cutscene {
    Play, // Server → client: start playing a cutscene sequence
    Skip, // Client → server: player wants to skip the cutscene
    End // Server → client: cutscene finished (cleanup)
}
